var map = {
	"./Groups/artigiani/ConfitureW255.png": 6148,
	"./Groups/artigiani/ConserveBioW255.png": 58660,
	"./Groups/artigiani/FromaggioW255.png": 73650,
	"./Groups/artigiani/MieleW255.png": 80175,
	"./Groups/artigiani/OlioRecW255.png": 64608,
	"./Groups/artigiani/TartufiFunghiW255.png": 60725,
	"./Groups/birre/BirraW255.png": 92503,
	"./Groups/birre/KitHomeBrewingW255.png": 52058,
	"./Groups/cantinette/CantinettaFiveW255.png": 83199,
	"./Groups/cantinette/CantinettaOneW255.png": 66037,
	"./Groups/cantinette/CantinettaThreeW255.png": 28693,
	"./Groups/cantinette/CantinettaTwoW255.png": 82415,
	"./Groups/cantinette/armadiettoW255.png": 83640,
	"./Groups/cestiregalo/CestoRegaloW255.png": 88245,
	"./Groups/distillati/DistillatiW255.png": 24667,
	"./Groups/offertaspeciale/BoxDegustationW255.png": 41496,
	"./Groups/offertaspeciale/OffertaSpecialeW255.png": 87627,
	"./Groups/offertaspeciale/PromosW255.png": 21478,
	"./Groups/spumanti/SpumanteAromatizzatiW255.png": 19918,
	"./Groups/spumanti/SpumanteCharmatW255.png": 97351,
	"./Groups/spumanti/SpumanteClassicoW255.png": 54404,
	"./Groups/ustensili/BicchieriW255.png": 10045,
	"./Groups/ustensili/CavatappOneW255.png": 36993,
	"./Groups/ustensili/CavatappiW255.png": 15084,
	"./Groups/ustensili/DecanterW255.png": 60755,
	"./Groups/ustensili/OssigenatoreTwoW255.png": 27678,
	"./Groups/ustensili/PortabottiglieOneW255.png": 64850,
	"./Groups/ustensili/PortabottiglieW255.png": 8326,
	"./Groups/ustensili/SetDegustazioneTwoW255.png": 45581,
	"./Groups/ustensili/SetDegustazioneW255.png": 76209,
	"./Groups/ustensili/TappoOneW255.png": 33401,
	"./Groups/ustensili/TappoTwoW255.png": 74147,
	"./Groups/ustensili/TermometriW255.png": 58655,
	"./Groups/vini/ViniAnnataW255.png": 4966,
	"./Groups/vini/ViniBianchiW255.png": 51743,
	"./Groups/vini/ViniBioW255.png": 71597,
	"./Groups/vini/ViniDessertW255.png": 7413,
	"./Groups/vini/ViniDolciW255.png": 60514,
	"./Groups/vini/ViniNaturaliW255.png": 45937,
	"./Groups/vini/ViniRoseW255.png": 24632,
	"./Groups/vini/ViniRossiW255.png": 98707,
	"./Prodotti/vinibianchi/VinoBiancoH400.png": 12315,
	"./Prodotti/vinibianchi/VinoBiancoH550.png": 30385,
	"./Prodotti/vinibiologici/VinoBioH550.png": 29494,
	"./Prodotti/vininaturali/VinoNaturaleH230.png": 80442,
	"./Prodotti/vininaturali/VinoNaturaleH550.png": 13851,
	"./Prodotti/viniparticolari/VinoAnataH550.png": 92254,
	"./Prodotti/viniparticolari/VinoDessertH550.png": 74407,
	"./Prodotti/viniparticolari/VinoDolceH550.png": 3000,
	"./Prodotti/vinirosati/VinoRosatoH400.png": 23127,
	"./Prodotti/vinirosati/VinoRosatoH550.png": 32101,
	"./Prodotti/vinirossi/BottleFourH400.png": 10161,
	"./Prodotti/vinirossi/BottleFourH550.png": 15511,
	"./Prodotti/vinirossi/BottleThreeH400.png": 30985,
	"./Prodotti/vinirossi/BottleThreeH550.png": 22767,
	"./Prodotti/vinirossi/VinoRossoH400.png": 79645,
	"./Prodotti/vinirossi/VinoRossoH550.png": 44779,
	"./categories/BirreArtigW280.png": 97579,
	"./categories/CavatappiW280.png": 88627,
	"./categories/CaveFrigoW280.png": 36218,
	"./categories/DistillatiW280.png": 5367,
	"./categories/PromoW280.png": 74705,
	"./categories/offerteW280.png": 86035,
	"./categories/regionaleW280.png": 76640,
	"./categories/scatolaSpumanteW280.png": 89730,
	"./categories/scatolaVinox4W280.png": 49415,
	"./labelbottiiglie/wineLabelEightRH550.png": 64935,
	"./labelbottiiglie/wineLabelEightVH550.png": 44403,
	"./labelbottiiglie/wineLabelFiveRH550.png": 32542,
	"./labelbottiiglie/wineLabelFiveVH550.png": 98370,
	"./labelbottiiglie/wineLabelFourRH550.png": 8718,
	"./labelbottiiglie/wineLabelFourVH550.png": 41330,
	"./labelbottiiglie/wineLabelOneRH550.png": 8848,
	"./labelbottiiglie/wineLabelOneVH550.png": 82132,
	"./labelbottiiglie/wineLabelSevenRH550.png": 80877,
	"./labelbottiiglie/wineLabelSevenVH550.png": 35009,
	"./labelbottiiglie/wineLabelSixRH550.png": 37908,
	"./labelbottiiglie/wineLabelSixVH550.png": 41328,
	"./labelbottiiglie/wineLabelThreeRH550.png": 28060,
	"./labelbottiiglie/wineLabelThreeVH550.png": 23736,
	"./labelbottiiglie/wineLabelTwoRH550.png": 41962,
	"./labelbottiiglie/wineLabelTwoVH550.png": 1926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22297;